import { useQuery } from "@tanstack/react-query";
import { getOrganization } from "../api/auth";

// Името на организацията не се променя по време на сесията — кешираме дълго.
// enabled=false спира заявката (напр. акаунт без organization_access).
export const useOrganization = (enabled = true) => {
  return useQuery({
    queryKey: ["organization"],
    queryFn: getOrganization,
    staleTime: Infinity,
    enabled,
  });
};
